<template>
	<div>
        <b-overlay rounded="sm" class="">
         <b-card no-body class="border-0 bg-transparent no-shadow employee-tab-bg">
            <div class="d-inline-block w-100">
                <div class="row pt-4">
                    <div class="col-md-3">
                        <div class="clearfix company-form-container h-100 p-3 payslip-list-dropdown">
                            <b-form-select v-model="fiscals" class="select_border_color2 " v-on:change="filterFiscalYear">
                                <b-form-select-option :value='sa' >Select Fiscal Year</b-form-select-option>
                                <b-form-select-option v-for="(fiscal_year,index)  in fiscal_years" :key="index" :value="fiscal_year.fiscal_year">
                                    {{fiscal_year.fiscal_year}}
                                </b-form-select-option>
                            </b-form-select>

                            <!-- Abdullah 13-04-26 added those two btns  -->

                            <template v-if="$acl['downloadtaxcards'] == 2">
                                <a v-if="taxcards.length > 0 && downloadable == 'yes'"
                                    :href="$api_url+'/employee_downloadtaxcards_all/'+fiscals"
                                    class="btn btn-primary btn-block mt-3">
                                    <b-icon icon="box-arrow-in-down" class="mr-2" scale="1"></b-icon> Download All Taxcard(s)
                                </a>
                                <a v-if="taxcards.length > 0 && downloadable == 'no'"
                                    :href="$api_url+'/employee_downloadpayslip_all/'+fiscals"
                                    class="btn btn-primary btn-block mt-3 pe-none disabled"
                                    aria-disabled="true">
                                    <b-icon icon="box-arrow-in-down" class="mr-2" scale="1"></b-icon> Download All Taxcard(s)
                                </a>
                            </template>

                             <!-- Abdullah 13-04-26 added those two btns  end -->

                            <div class="col-md-12  payslip-month-list-item-container cursor-pointer" :class="{ 'active': activeIndex === index }" v-for="(taxcard,index)  in taxcards" :key="taxcard.id" @click="paySlipLoad(taxcard.id,index)">
                                <template>
                                    <div class="payslip-month-list-item clearfix py-3 px-1"  >
                                        <div class="payslip-month-list-item-left" :class="{ 'table_text_color': activeIndex === index }">
                                            {{taxcard.month}}
                                        </div>
                                        <div class="payslip-month-list-item-right" :class="{ 'table_text_color': activeIndex === index }">
                                            {{taxcard.year}}
                                        </div>

                                    </div>
                                </template>
                            </div>

                        </div>
                    </div>

                    <div class="col-md-9" v-if="selected_payslip.id > 0">
                        <div class="clearfix company-form-container h-100 p-3">
                            <template v-if="selected_payslip.finance_bill == 'new'">
                                <taxcarddetailsnew :pageurl="$api_url" :taxcard="selected_payslip.id" :company="companies[selected_payslip.company_id]" :cardname="'Tax Card for '+empdata.name+' (eTIN-'+empdata.etin+') - '+selected_payslip.month+' '+selected_payslip.year" :pmonth="selected_payslip.month" :pyear="selected_payslip.year" :dynamic_fields="dynamic_fields" :key='detail_key'>
                                </taxcarddetailsnew>
                            </template>
                            <template v-else>
                                <taxcarddetails :pageurl="$api_url" :taxcard="selected_payslip.id" :company="companies[selected_payslip.company_id]" :cardname="'Tax Card for '+empdata.name+' (eTIN-'+empdata.etin+') - '+selected_payslip.month+' '+selected_payslip.year" :pmonth="selected_payslip.month" :pyear="selected_payslip.year" :dynamic_fields="dynamic_fields" :key='detail_key'>
                                </taxcarddetails>
                            </template>

                        </div>
                    </div>
                    <div class="col-md-9" v-else>
                        <div class="clearfix company-form-container h-100 p-3">
                            <div class='no-data-wrapper'>
                                No Data found
                            </div>
                        </div>
                    </div>
                </div>
            </div>
         </b-card>
        </b-overlay>
	</div>
</template>
<script>
    import moment from 'moment';
    export default{
        mounted() {
        },
        computed: {
        },
        props: [],
        data(){
            return {
                taxcards: [],
                empdata: [],
                emp_public_info: [],
                companies: [],
                acccards:[],
                fiscal_years: [],
                fiscals: null,
                curr_fiscal: [],

                tas: false,
                current_f_year: '',
                emp_joinng_date: '',
                emp_date_of_birth: '',
                downloadable: 'yes',
                dynamic_fields:{},

                sa:null,
                selected_payslip: [],

                // Abdullah live in secure add this
                  activeIndex:-1,
                  detail_key:0,
            }// Abdullah live in secure add here  uopto this
        },
        methods:{
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },

           getEmployeePublicInfo: function()
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/employee/publicinfo' , {
                    params: {

                    }
                }).then(function(response){
                    this.emp_public_info = response.data;
                    this.emp_joinng_date =  moment(String(response.data.date_of_joining)).format('D MMMM YYYY');
                    if(response.data.date_of_birth && response.data.date_of_birth !='0000-00-00')
                    this.emp_date_of_birth = moment(String(response.data.date_of_birth)).format('D MMMM YYYY');

                }.bind(this));
            },

            getPayslipDynamicFieldData:function(emp_id)
            {
                axios.get(this.$api_url+'/company/payslip-field-settings/get-employee-dynamic-field-data', {
                            params: {
                                employee_id: emp_id
                            }
                    }).then(function(response){
                        var ltData = response.data;
                        this.dynamic_fields =ltData;

                }.bind(this));
            },

           getTaxCards: function(f_year='')
            {
                   axios.get(this.$api_url+'/employeetaxcards', {
                            params: {
                                fiscal_year: f_year
                            }
                    }).then(function(response){
                    this.taxcards = response.data.data.cards;
                    this.empdata = response.data.data.employee_info;
                    this.getPayslipDynamicFieldData(this.empdata.employee_id);
                    this.companies = response.data.data.companies;
                    this.fiscal_years = response.data.data.fiscal_years;
                    this.curr_fiscal = response.data.data.fiscal_year;
                    this.fiscals = response.data.data.fiscal_year;
                    this.downloadable = response.data.data.downloadable;
                    //alert(response.data.data.current_fiscal_year)
                    //this.fiscals=response.data.data.current_fiscal_year;

// Abdullah live in secure add  this
                    if(this.taxcards.length > 0){
                        this.selected_payslip  = this.taxcards[0];
                        this.activeIndex = 0;
                    }
                    // Abdullah live in secure add here  uopto this
                }.bind(this));
            },

            // Abdullah live in secure add here  uopto this
             paySlipLoad(card_id,index){
                if(parseInt(card_id)){

                    this.activeIndex = index;
                    this.selected_payslip  = this.taxcards.find(item => item.id === card_id);
                    console.log(card_id);
                    console.log(this.selected_payslip);

                    this.detail_key += 1;

                }
                else
                {
                    this.selected_payslip = [];
                    this.activeIndex = -1;
                    this.detail_key += 1;
                }
            },

            // Abdullah live in secure add here  uopto this
            taxCardLoad(card_id){
                if(parseInt(card_id)){
                this.$set(this.acccards,card_id,1);
                }
            },
            filterFiscalYear(f_year){
                this.getTaxCards(f_year);
            },
            onSubmit:function(e)
            {
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }
                e.preventDefault();
                let currentObj = this;
                });
            },
        },
        created: function(){
            this.getEmployeePublicInfo();
            this.getTaxCards();
            //this.f_year=this.current_f_year;

        }
    }
</script>
